import React, {useEffect, useRef, useState} from 'react';
import LFCBaseCharts from '_components/charts/base/LFCBaseCharts';
import {isEmpty} from 'lodash';
import {useTranslation} from 'react-i18next';

/**
 * 引数
 */
interface Props {
  title: string;
  x: {dsColumn: string};
  series?: {name: string; dsColumn: string}[];
  source: any;

  exportData?: any;
  exportFields?: any;
  exportFilename?: string;
  height?: string;
  onClick?: (prm: {data: any}) => void;
  mapName?: string;
  zoomCharts?: any;
  zoomChartsClose?: any;
  zoomChartId?: string;
  zoomedChartId?: string;
  zoomStatus?: boolean;
}

/**
 * LFCChartsLineGap
 * @param props
 * @returns
 */
const LFCChartsLineSurfaceCompareDot = React.memo((props: Props) => {
  const {t} = useTranslation();
  const renderFlgRef = useRef(false);

  const [makeBranchNoData, setMakeBranchNoData] = useState<any>([]);

  useEffect(() => {
    if (!renderFlgRef.current) {
      // 初期描画時のみの処理
      renderFlgRef.current = true;
      return;
    }
    let branch_no: any = props.source.map((a: any) => a.branch_no);
    let tmp: any = [];
    branch_no.forEach((a: any) => {
      tmp.push({
        name: a,
        data:
          props.source.length > 0 &&
          props.source
            .filter((c: any) => c.branch_no === a)[0]
            ['data_value'].map((b: any) => Number(b.min_ratio)),
        type: 'effectScatter',
        colorBy: 'series',
        rippleEffect: {
          number: 0,
          scale: 0,
          period: 0
        }
      });
    });
    setMakeBranchNoData(tmp);
  }, [props.source]);

  return (
    <div style={{width: '100%'}}>
      <LFCBaseCharts
        option={{
          title: {
            text: props.title
          },
          grid: {
            top: '65',
            left: '60',
            right: '10',
            bottom: '20',
            containLabel: true
          },
          legend: {
            id: 1,
            type: 'scroll',
            itemWidth: 10,
            show: true,
            bottom: 0,
            textStyle: {
              fontSize: 10
            },
            formatter: `${t('追番')}{name}${t('最小値')}`
          },
          tooltip: {
            trigger: 'item',
            formatter: (params: any) => {
              let tmp: string;
              tmp = t('連番') + ':' + params.name + '</br>';
              tmp +=
                t('シリアルナンバー') +
                ':' +
                props.exportData.filter((a: any) => a.idx === Number(params.name))[0].serial +
                '</br>';
              tmp +=
                t('検査日時') +
                ':' +
                props.exportData.filter((a: any) => a.idx === Number(params.name))[0].lq_time +
                '</br>';
              tmp += t('検査追番号') + ':' + params.seriesName + '</br>';
              tmp +=
                t('閾値') +
                ':' +
                props.exportData.filter((a: any) => a.idx === Number(params.name))[0].threshold +
                '</br>';
              tmp += t('マッチング率') + ':' + Math.round(params.data * 100) / 100;
              return tmp;
            }
          },
          dataZoom: [
            {
              type: 'inside'
            }
          ],
          series: makeBranchNoData,
          xAxis: [
            {
              type: 'category',
              axisLabel: {
                rotate: '30',
                fontSize: 10
              },
              data:
                !isEmpty(props.source) && props.source[0]['data_value'] !== undefined
                  ? props.source[0]['data_value'].map((a: any) => a.idx)
                  : []
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: t('マッチング率(%)'),
              max: 100,
              nameTextStyle: {
                fontSize: 10
              },
              axisLabel: {
                interval: 0,
                fontSize: 10
              }
            }
          ]
        }}
        exportData={props.exportData}
        exportFields={props.exportFields}
        exportFilename={props.exportFilename}
        height={props.height !== undefined ? props.height : '300px'}
        onEvents={{
          click: (params: any) => {
            if (props.onClick != null) {
              params.mapName = props.mapName;
              props.onClick(params);
            }
          }
        }}
        zoomCharts={props.zoomCharts ? props.zoomCharts : undefined}
        zoomChartsClose={props.zoomChartsClose ? props.zoomChartsClose : undefined}
        zoomChartId={props.zoomChartId ? props.zoomChartId : undefined}
        zoomStatus={props.zoomChartId === props.zoomedChartId}
      />
    </div>
  );
});
export default LFCChartsLineSurfaceCompareDot;
